import {Component, OnInit} from '@angular/core';
import {SiteInfosService, WindowRefService} from '@app/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-footer-book',
  templateUrl: './footer-book.component.html',
  styleUrls: ['./footer-book.component.scss']
})
export class FooterBookComponent implements OnInit {
  channelManager = {};
  year: number = 2022;
  status: boolean = false;
  data: any = {};

  constructor(
    private winRef: WindowRefService,
    private siteInfosService: SiteInfosService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.channelManager = this.siteInfosService.getEtabData()[
      'udChannelManger'
    ];
    this.year = new Date().getFullYear();
    const etabData = this.siteInfosService.getEtabData();
    this.data = {
      etabName: etabData['etablissementNom'],
      adresse: etabData['etabAdresse'],
      codePostal: etabData['etabCodepost'],
      city: etabData['etabVille'],
      country: etabData['etabPays'],
      email: etabData['etabMail'][0]
    };
  }

  openTechProv() {
    this.status = !this.status;
  }

  openPrivacy(content) {
    this.modalService.open(content, {
      size: 'lg', 
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'privacy-modal-dialog',
    }).result.then((result) => {
      // console.log(`Closed with: ${result}`);
    }, (reason) => {
      // console.log(`Dismissed ${reason}`);
    });
  }
}
